import { create } from 'zustand';

export const DEFAULT_MY_WORK_SEARCH_PARAMS = Object.freeze({
	page: 1,
	pageSize: 15,
	sortBy: 'createdAt',
	sortOrder: 'desc',
	search: '',
});

export const usePendingChangeStore = create((set) => ({
	items: [],
	loading: false,
	error: null,
	selectedItem: null,
	paginationData: { total: 0, totalPages: 0, page: 1, pageSize: 15 },
	searchParams: { ...DEFAULT_MY_WORK_SEARCH_PARAMS },
	uniqueValues: {},

	submissionsItems: [],
	submissionsLoading: false,
	submissionsError: null,
	submissionsPaginationData: { total: 0, totalPages: 0, page: 1, pageSize: 15 },
	submissionsSearchParams: { page: 1, pageSize: 15, sortBy: 'createdAt', sortOrder: 'desc', search: '' },
	submissionsUniqueValues: {},

	involvementItems: [],
	involvementLoading: false,
	involvementError: null,
	involvementPaginationData: { total: 0, totalPages: 0, page: 1, pageSize: 15 },
	involvementSearchParams: { page: 1, pageSize: 15, sortBy: 'createdAt', sortOrder: 'desc', search: '' },
	involvementUniqueValues: {},

	informedItems: [],
	informedLoading: false,
	informedError: null,
	informedPaginationData: { total: 0, totalPages: 0, page: 1, pageSize: 15 },
	informedSearchParams: { page: 1, pageSize: 15, sortBy: 'createdAt', sortOrder: 'desc', search: '' },
	informedUniqueValues: {},

	isDetailDialogOpen: false,
	detailContext: 'approver',
	isApproveDialogOpen: false,
	isRejectDialogOpen: false,

	setItems: (items) => set({ items }),
	setLoading: (loading) => set({ loading }),
	setError: (error) => set({ error }),
	clearError: () => set({ error: null }),
	setSelectedItem: (selectedItem) => set({ selectedItem }),
	setPaginationData: (paginationData) => set({ paginationData }),
	setSearchParams: (params) => set((s) => ({ searchParams: { ...s.searchParams, ...params } })),
	replaceSearchParams: (searchParams) => set({ searchParams }),
	resetPendingQuery: () => set({
		searchParams: { ...DEFAULT_MY_WORK_SEARCH_PARAMS },
	}),
	setUniqueValues: (uniqueValues) => set({ uniqueValues }),

	setSubmissionsItems: (submissionsItems) => set({ submissionsItems }),
	setSubmissionsLoading: (submissionsLoading) => set({ submissionsLoading }),
	setSubmissionsError: (submissionsError) => set({ submissionsError }),
	clearSubmissionsError: () => set({ submissionsError: null }),
	setSubmissionsPaginationData: (submissionsPaginationData) => set({ submissionsPaginationData }),
	setSubmissionsSearchParams: (params) => set((s) => ({ submissionsSearchParams: { ...s.submissionsSearchParams, ...params } })),
	setSubmissionsUniqueValues: (submissionsUniqueValues) => set({ submissionsUniqueValues }),

	setInvolvementItems: (involvementItems) => set({ involvementItems }),
	setInvolvementLoading: (involvementLoading) => set({ involvementLoading }),
	setInvolvementError: (involvementError) => set({ involvementError }),
	clearInvolvementError: () => set({ involvementError: null }),
	setInvolvementPaginationData: (involvementPaginationData) => set({ involvementPaginationData }),
	setInvolvementSearchParams: (params) => set((s) => ({ involvementSearchParams: { ...s.involvementSearchParams, ...params } })),
	setInvolvementUniqueValues: (involvementUniqueValues) => set({ involvementUniqueValues }),

	setInformedItems: (informedItems) => set({ informedItems }),
	setInformedLoading: (informedLoading) => set({ informedLoading }),
	setInformedError: (informedError) => set({ informedError }),
	clearInformedError: () => set({ informedError: null }),
	setInformedPaginationData: (informedPaginationData) => set({ informedPaginationData }),
	setInformedSearchParams: (params) => set((s) => ({ informedSearchParams: { ...s.informedSearchParams, ...params } })),
	setInformedUniqueValues: (informedUniqueValues) => set({ informedUniqueValues }),

	openDetailDialog: (item, detailContext = 'approver') => set({ isDetailDialogOpen: true, selectedItem: item, detailContext }),
	closeDetailDialog: () => set({ isDetailDialogOpen: false, selectedItem: null, detailContext: 'approver' }),
	openApproveDialog: (item) => set({ isApproveDialogOpen: true, selectedItem: item }),
	closeApproveDialog: () => set({ isApproveDialogOpen: false }),
	openRejectDialog: (item) => set({ isRejectDialogOpen: true, selectedItem: item }),
	closeRejectDialog: () => set({ isRejectDialogOpen: false }),

	removeItem: (id) => set((s) => ({ items: s.items.filter((item) => item._id !== id && item.id !== id) }))
}));
